<script>
/* global L : true*/
import { OnCampsiteAdded, OnCampsiteClear } from './../../js/app_state'

export default {
    name: "CampingSitesMixin",

    data() {
        return {
            camp_site_markers: [],
        }
    },

    mounted() {
        OnCampsiteAdded.push((loc, info) => { this.onCampsiteAdded(loc, info); });
        OnCampsiteClear.push(() => { this.camp_site_markers.forEach((cs_marker) => { cs_marker.remove(); }); });
    },

    methods: {
        onCampsiteAdded(loc, info) {
            const camp_site_icon = L.icon({iconUrl: 'camping_tent.png',
                                iconSize: [24, 17],
                        });
            var new_marker = L.marker(this.mymap.getCenter(), {icon: camp_site_icon}).addTo(this.mymap);
            new_marker.setLatLng(L.latLng([loc[0], loc[1]]));
            this.camp_site_markers.push(new_marker);

            // marker popup construction
            var marker_popup = "";
            if (info.name !== undefined) {
                marker_popup += info.name.bold();
                }
            if (info.addr !== undefined) {
                marker_popup += "<br>";
                marker_popup += info.addr;
            }
            if (info.phone !== undefined) {
                const phone_without_space = info.phone.replace(/\s/g, '');
                marker_popup += "<br>";
                marker_popup += "<a href=tel:" + phone_without_space + ">" + info.phone + "</a>";
            }
            if (info.website !== undefined) {
                marker_popup += "<br>";
                marker_popup += "<a href=" + info.website +  " target='_blank'>" + info.website + "</a>";
            }
            // marker popup binding
            if (marker_popup !== "")
                new_marker.bindPopup(marker_popup);
            else
                new_marker.bindPopup("No information available for this campsite");
        },

    },
}
</script>